import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalContentComponent } from '../../component/modal-content/modal-content.component';
import { OperatorEnum } from '../../ui/OperatorUtil';

@Component({
  selector: 'app-condition-query-lookup-input-type',
  templateUrl: './condition-query-lookup-input-type.component.html',
  styleUrl: './condition-query-lookup-input-type.component.scss'
})
export class ConditionQueryLookupInputTypeComponent extends FieldType {
  isModalOpen: boolean = false;
  modalRef!: BsModalRef;
  text: string = "";
  @ViewChild('value') lookupCodeBox!: ElementRef;
  isChecked: boolean = false;
  conditionTypeName: string = "";
  isfreetext: boolean = false;
  tooltip: string = "";
  isPaste: boolean = false;

  onCheckboxChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.isChecked = input.checked;
    this.lookupCodeBox.nativeElement.value = null
    this.text = '';
  }

  constructor(private modalService: BsModalService,
    private cdRef: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
      if (this.formControl.value) {
        this.isChecked = true;
        this.text = this.props["text"]!;     
      } else {
        this.isChecked = false;
      }
      
      this.props["isfreetext"] ? this.isfreetext = true : this.isfreetext = false;
      this.props["description"] ? this.tooltip = this.props.description : this.tooltip = "Search by " + this.props.label;
  }

  manageCheck() {
    if (this.isChecked) {
      this.isChecked = !this.isChecked;
      if (!this.isChecked) {
        this.text = "";
        this.lookupCodeBox.nativeElement.value = null;
        this.formControl.setValue(null);
      }
    }
  }


  openModal() {
    let value = this.formControl.getRawValue();

    if (this.isModalOpen) return;
    this.isModalOpen = true; // Set flag to true

    //Retrieve the lookup metadata object
    const lookup: any = this.field.props!['lookup'];

    //Show modal dialog
    this.modalRef = this.modalService.show(ModalContentComponent,
      {
        initialState: {
          message: { lookup: lookup, selectedValue: value, isCondition: true }
        }
      }
    );

    //Close modal suscription 
    this.modalRef.onHidden!.subscribe(() => {
      this.isModalOpen = false;
      if (this.modalRef.content.selectedName) {
        if (this.modalRef.content.selectedName === "blank") {
          this.text = "";
          this.formControl.setValue(null);
          this.isChecked = false;
        } else if (lookup.result) {
          this.text = "";
          this.isChecked = true;
          this.formControl.setValue(this.modalRef.content.selectedCode);
          this.props["text"] = this.text;
          this.props["conditionType"] = OperatorEnum.OperatorEqual;
        } else {
          this.text = this.modalRef.content.selectedName;
          this.isChecked = true;
          this.formControl.setValue(this.modalRef.content.selectedCode);
          this.props["text"] = this.text;
          this.props["conditionType"] = OperatorEnum.OperatorEqual;
        }
      } else if (this.modalRef.content.selectedItems){
        this.text = "";
        this.isChecked = true;
        this.formControl.setValue(this.modalRef.content.selectedItems);
        this.props["conditionType"] = OperatorEnum.OperatorIn;
      }
      this.props['defaultValue'] = this.formControl.value && this.formControl.value != ""?this.formControl.value:null;
      this.cdRef.detectChanges();
    });
  }

  onInputChange() {
    if (this.formControl.value) {
      this.isChecked = true;
      this.props['isModified'] = true;
      if (!this.modalRef || this.modalRef.content.selectedCode != this.formControl.value) {
        this.text = "";
        this.props["text"] = "";
      }
    } else {
      this.isChecked = false;
      this.text = "";
      this.props['isModified'] = false;
      this.props['conditionType'] = "";
    }
    this.props['defaultValue'] = this.formControl.value && this.formControl.value != ""?this.formControl.value:null;
    this.manageConditionType();
  }

onPaste(event: ClipboardEvent) {
  event.preventDefault();

  const pastedText = event.clipboardData?.getData('text') || '';

  const cleanText = pastedText
    .split(/\r?\n/)                       // separa por líneas
    .map(s => s.replace(/"/g, ''))        // elimina comillas dobles
    .map(s => s.trim())                   // quita tabs y espacios delante/detrás
    .filter(Boolean)                      // elimina líneas vacías
    .join('|');                           // únelas con |

  const target = event.target as HTMLTextAreaElement;

  target.setRangeText(cleanText, target.selectionStart, target.selectionEnd, 'end');

  this.formControl.setValue(target.value);

  setTimeout(() => {
    this.manageConditionType();
    this.isChecked = true;
  });
}

  getConditionTypeName() {
    let result = "";
    switch (this.props["conditionType"]) {
      case "eq":
        result = "(Matches)";
        break;
      case "in":
        result = "(With)";
        break;
      case "cn":
        result = "(Contains)"
        break;
        default: "";
    }
    return result;
  }

  private manageConditionType() {
    if (this.formControl.value) {
        if (typeof this.formControl.value == 'string' && this.formControl.value.includes('|')) {
            const values =  this.formControl.value.split('|').map(v => v.trim());
            if (values.length > 1 && values.every(v => v.length > 0)) {
              this.props['conditionType'] = OperatorEnum.OperatorIn;
            } else if (!this.isfreetext) {
              this.props['conditionType'] = OperatorEnum.OperatorEqual
            } else {
               this.props['conditionType'] = OperatorEnum.OperatorContain
            }
        } else if (!this.isfreetext || this.isPaste) {
            this.isPaste = !this.isPaste;
            this.props['conditionType'] = OperatorEnum.OperatorEqual
        } else {
            this.props['conditionType'] = OperatorEnum.OperatorContain;
        } 
    }
  }
}
